module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-BoldSemiCnIt.ddf7d1d.woff";